<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col cols="12" class="">
          <!-- ProjectStatus -->
          <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="text-dark mr-3"><i class="el-icon-s-data"></i></div>
                <div class="h4 font-weight-bold text-dark">Haandvaerker - Projekt status</div>
              </div>
            </div>
          </b-card>
          <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="h6 open-sans line-height-golden py-4">
              Her kan du se status på dine projekter. Har du spørgsmål til et af dine projekter, så er du velkommen til at skrive til info@haandvaerker.dk.
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col>
          <haandvaerkerstatuslist></haandvaerkerstatuslist>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import haandvaerkerstatuslist from './haandvaerker/NewStatusList'
export default {
  components: {
    haandvaerkerstatuslist
  }
}
</script>
<style scoped>
.main .container-fluid {
  padding: 15px 0;
}
.fa-heartbeat {
  font-size: 26px;
}
</style>


// WEBPACK FOOTER //
// NewHaandvaerkerProjectStatus.vue?799b2d3e